import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { MetaContent } from "@@/shared/meta-content/meta-content";
import type { Quantity } from "@@/shared/units-and-quantities/quantity";
import type { Except } from "type-fest";
import type { ResourcePrice } from "../resource-price/resource-price";
import type { ResourceReferenceId } from "../resource-references/resource-reference-id";
import type { ResourceId } from "../resources/resource-id";
import type { BookableOptionId } from "./bookable-option-id";
import type {
    BookableOptionValueId} from "./bookable-option-value-id";
import {
    bookableOptionValueIdFactory,
} from "./bookable-option-value-id";

type QuantityPickerBookableOptionValue = {
    readonly _id: BookableOptionValueId;
    readonly _type: "QUANTITY_PICKER_BOOKABLE_OPTION_VALUE";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly parentId: BookableOptionId;
    readonly resourceReferenceId: ResourceReferenceId;
    readonly resourceId: ResourceId;
    readonly meta: MetaContent;
    readonly resourcePrice: ResourcePrice;
    readonly quantity: Quantity;
};

type quantityPickerBookableOptionValueFactoryParams = Except<
    QuantityPickerBookableOptionValue,
    "_id" | "_type" | "_createdAt"
>;

const quantityPickerBookableOptionValueFactory = (
    params: quantityPickerBookableOptionValueFactoryParams,
): QuantityPickerBookableOptionValue => {
    return {
        ...params,
        _id: bookableOptionValueIdFactory(),
        _type: "QUANTITY_PICKER_BOOKABLE_OPTION_VALUE",
        _createdAt: nowIsoAndUnix(),
    };
};

const isQuantityPickerBookableOptionValue = (
    item:
        | {
              _id: BookableOptionValueId;
              _type: unknown;
          }
        | undefined,
): item is QuantityPickerBookableOptionValue => {
    if (typeof item === "undefined") return false;
    return item._type === "QUANTITY_PICKER_BOOKABLE_OPTION_VALUE";
};

export {
    isQuantityPickerBookableOptionValue,
    quantityPickerBookableOptionValueFactory,
};
export type { QuantityPickerBookableOptionValue };
